import { hasYesOrNo } from 'models/validate';
import { DEFAULT_LATEST, THIS_MONTH, TODAY } from 'constants/dateLimits';
import { ValidateJSModel } from 'forms/shared/types';
import { getSafeDateTime, isSafeDateLater, setToStartOfMonth } from 'helpers/date';
import { formConfig } from 'config/forms';
import { SafeDateTime } from 'helpers/types';
import { isPVQForm } from 'helpers/form';
import { SubstanceThcUsageItemModel } from '../types';

const substanceThcUsageItemValidator: ValidateJSModel<SubstanceThcUsageItemModel> = {

  FirstUse: (value, attributes, attributeName, options) => ({
    presence: true,
    date:
    {
      requireDay: false,
      earliest: setToStartOfMonth(options?.applicantBirthdate),
      tooEarly: 'error.alcohol.negativeImpact.occurred.error.tooEarly',
      latest: DEFAULT_LATEST
    },
  }),
  RecentUse: (value, attributes, attributeName, options) => {
    if (!attributes?.FirstUse) {
      return {};
    }
    let isYearRequired = false;
    if (isPVQForm(options?.formType)) {
      isYearRequired = true;
    }

    const formTypeConfig = options?.formType && formConfig[options?.formType as keyof typeof formConfig];
    const applicantEighteenthBirthdate: SafeDateTime | undefined = options?.applicantBirthdate && getSafeDateTime(getSafeDateTime(options?.applicantBirthdate)?.datetime?.plus({ years: 18 }));
    const years: any = formTypeConfig && formTypeConfig.SUBSTANCE_DRUG_USE_YEARS;

    let beyondRequired: SafeDateTime = getSafeDateTime(THIS_MONTH);
    let useDuration = false;

    if (years && beyondRequired?.valid && typeof years === 'number') {
      if (options?.formType && options?.formType === 'SF86' && applicantEighteenthBirthdate?.valid
        && applicantEighteenthBirthdate.datetime.year < (TODAY.year - years)) {
        beyondRequired = setToStartOfMonth(applicantEighteenthBirthdate);
      } else {
        beyondRequired.datetime = beyondRequired?.datetime.minus({ years });
      }

      useDuration = isSafeDateLater(beyondRequired, getSafeDateTime(attributes?.FirstUse));
    }

    return {
      presence: true,
      date: {
        requireDay: false,
        requireYear: isYearRequired,
        latest: DEFAULT_LATEST,
        earliest: useDuration ? setToStartOfMonth(beyondRequired).datetime : attributes?.FirstUse,
        tooEarly: useDuration ? 'error.beforeDuration' : 'error.drugUsage.min',
      },
    };
  },

  HowManyTimes: (value, attributes, attributeName, options) => {
    if (isPVQForm(options?.formType)) {
      return { presence: true, hasValue: true };
    }
    return {};
  },
  Reason: (value, attributes, attributeName, options) => {
    if (isPVQForm(options?.formType)) {
      return { presence: true, hasValue: true };
    }
    return {};
  },
  NatureOfUse: (value, attributes, attributeName, options) => {
    if (isPVQForm(options?.formType)) {
      return {};
    }
    return { presence: true, hasValue: true };
  },
  Explanation: (value, attributes, attributeName, options) => {
    if (options?.requireUseInFuture === false) { return {}; }
    return { presence: true, hasValue: true };
  },
  UseWhileEmployed: (value, attributes, attributeName, options) => {
    if (isPVQForm(options?.formType)) {
      return { presence: true, hasValue: { validator: hasYesOrNo } };
    }
    if (options?.requireUseWhileEmployed === false) { return {}; }
    return { presence: true, hasValue: { validator: hasYesOrNo } };
  },
  UseWithClearance: (value, attributes, attributeName, options) => {
    if (isPVQForm(options?.formType)) {
      return { presence: true, hasValue: { validator: hasYesOrNo } };
    }
    if (options?.requireUseWithClearance === false) { return {}; }
    return { presence: true, hasValue: { validator: hasYesOrNo } };
  },
  UseInFutureClearanceOrSafety: (value, attributes, attributeName, options) => {
    if (isPVQForm(options?.formType)) {
      return { presence: true, hasValue: { validator: hasYesOrNo } };
    }
    if (options?.requireUseInFuture === false) { return {}; }
    return { presence: true, hasValue: { validator: hasYesOrNo } };
  },
  UseInFutureGovernment: (value, attributes, attributeName, options) => {
    if (isPVQForm(options?.formType)) {
      return { presence: true, hasValue: { validator: hasYesOrNo } };
    }
    if (options?.requireUseInFuture === false) { return {}; }
    return { presence: true, hasValue: { validator: hasYesOrNo } };
  },

  UseInFutureClearanceOrSafetyExplanation: (value, attributes, attributeName, options) => {
    if (isPVQForm(options?.formType)) { return { presence: true, hasValue: true }; }
    return {};
  },
  UseInFutureGovernmentExplanation: (value, attributes, attributeName, options) => {
    if (isPVQForm(options?.formType)) { return { presence: true, hasValue: true }; }
    return {};
  },
  UseWhileEmployedExplanation: (value, attributes, attributeName, options) => {
    if (isPVQForm(options?.formType) && attributes?.UseWhileEmployed?.value === 'Yes') { return { presence: true, hasValue: true }; }
    return {};
  },
  UseWhileEmployedPosition: (value, attributes, attributeName, options) => {
    if (isPVQForm(options?.formType) && attributes?.UseWhileEmployed?.value === 'Yes') {
      return { presence: true, hasValue: true };
    }
    return {};
  },
  UseWithClearanceExplanation: (value, attributes, attributeName, options) => {
    if (isPVQForm(options?.formType) && attributes?.UseWithClearance?.value === 'Yes') { return { presence: true, hasValue: true }; }
    return {};
  },
  Comments: {},
};

export default substanceThcUsageItemValidator;
